/*
 * -----------------------------------------------------------------------
 *  <copyright file="admin-risks.helper.ts" company="Triumph Research Intelligence">
 *      Copyright (C) 2023 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import { LibraryRiskFieldsExtended } from '@interfaces/library-risk.interface';
import { useDateTime, useGridCells } from '@hooks/index';
import { convertBooleanToYesNo } from '@utils/convertor';

const { YesNoCell, DateCell, MaxLengthCell } = useGridCells();
const dateTime = useDateTime();

export const GET_ADMIN_RISK_REORDERING_GRID_COLUMNS = (translate: (value: string) => string) => [
    {
        label: translate('ra:controls'),
        field: 'numberOfControls',
        id: 'risk-controls',
        minWidth: 150,
    },
    {
        label: translate('ra:statement'),
        field: 'statement',
        id: 'risk-statement',
        minWidth: 180,
        cells: { data: MaxLengthCell(150) },
    },
    {
        label: translate('admin:riskLibraryCategory'),
        id: 'risk-library-category',
        minWidth: 220,
        field: 'riskLibraryCategory',
    },
    {
        label: translate('active'),
        id: 'risk-active',
        field: '_active',
        minWidth: 140,
        cells: { data: YesNoCell },
    },
    {
        label: translate('ra:createdBy'),
        field: '_createdByString',
        id: 'risk-createdby',
        minWidth: 170,
    },
    {
        label: translate('ra:createdDate'),
        field: 'created',
        id: 'risk-created',
        minWidth: 180,
        cells: { data: DateCell },
    },
    {
        label: translate('ra:updatedBy'),
        field: '_updatedByString',
        id: 'risk-updatedby',
        minWidth: 180,
    },
    {
        label: translate('ra:updatedDate'),
        field: 'updated',
        id: 'risk-updated',
        minWidth: 180,
        cells: { data: DateCell },
        filter: 'date',
    },
];

export const updateRisksReorderingGridData = (columns: LibraryRiskFieldsExtended[]): LibraryRiskFieldsExtended[] =>
    columns.map((column) => ({
        ...column,
        created: dateTime.displayDate(column.created),
        updated: dateTime.displayDate(column.updated),
        _active: convertBooleanToYesNo(!!column.active),
    }));
